export default (money) => {
  if (!money || Number.isNaN(Number(money))) return '';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(money);
};
